export default __webpack_public_path__ + "assets/images/button-thumb-down.dcaeb31d25adb4035cf60c7dc7dc02a7.svg";